import { StatusModel } from "../../general";
import { PeripheralTopicItemModel } from "./peripheral-topic-item";

export interface PeripheralMetricsModel {
  utilisation: StatusModel;
  series: PeripheralTopicItemModel[];
}

export interface PeripheralChildModel {
  name: string;
  value: string;
  type: string;
}
